import { VStack } from "@chakra-ui/react"
import { useCreateFormData } from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import ActivityCreateLoading from "./ActivityCreateLoading"
import OrderContextBanner from "./OrderContextBanner"

function ActivityCreateScreenWrapper({ children }: { children: React.ReactNode }) {
  const createFormData = useCreateFormData()
  if (!createFormData) return <ActivityCreateLoading />
  return (
    <VStack gap={4} align="stretch" width="100%">
      <OrderContextBanner />
      {children}
    </VStack>
  )
}

export default ActivityCreateScreenWrapper
